// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
// import { hitApi } from "./utils/apiCall";

// const ProtectedRoute = () => {
//   const navigate = useNavigate();
//   const [isLoggedIn, setIsLoggedIn] = useState(() => {
//     // Initialize isLoggedIn based on localStorage value
//     return !!localStorage.getItem("token");
//   });

//   const location = useLocation();
//   const hideMenuRoutes = ["/login"];

//   useEffect(() => {
//     const authToken = localStorage.getItem("authToken");
//     if (!authToken) {
//       navigate("/auth/login");
//     }
//     const fetchMenu = async () => {
//       const res = await hitApi(
//         "permission/permission",
//         "getMenuDetails",
//         new FormData()
//       ); // replace with your API
//       // const res = await hitApi('permission/permission', 'getMenuDetails', new FormData()); // replace with your API

//       if (res.code === 403) {
//         localStorage.clear();
//         navigate("/login");
//       }
//     };
//     fetchMenu();
//   }, [navigate]);

//   useEffect(() => {
//     // Check login status on mount (useful if there's a need for API verification)
//     const authToken = localStorage.getItem("token");
//     setIsLoggedIn(!!authToken);
//   }, []);

//   return isLoggedIn ? <Outlet /> : <Navigate to="/login" replace />;
// };

// export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { hitApi } from "./utils/apiCall";

// const ProtectedRoute = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [loading, setLoading] = useState(true); // New state

//   useEffect(() => {
//     const checkAuth = async () => {
//       const authToken = localStorage.getItem("authToken");
//       if (!authToken) {
//         setIsLoggedIn(false);
//         setLoading(false);
//         return;
//       }

//       try {
//         const res = await hitApi(
//           "permission/permission",
//           "getMenuDetails",
//           new FormData()
//         );
//         if (res.code === 403) {
//           localStorage.clear();
//           setIsLoggedIn(false);
//         } else {
//           setIsLoggedIn(true);
//         }
//       } catch (err) {
//         console.error("API error:", err);
//         setIsLoggedIn(false);
//       }
//       setLoading(false); // ✅ done checking
//     };
//     checkAuth();
//   }, []);

//   // Still checking auth
//   if (loading) return null; // or a loading spinner

//   // Not logged in or unauthorized
//   if (!isLoggedIn) return <Navigate to="/login" replace />;

//   // Authorized
//   return <Outlet />;
// };

// export default ProtectedRoute;

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

const ProtectedRoute = () => {
  const { isLoggedIn, loading } = useAuth();

  if (loading) return null; // or a spinner
  if (!isLoggedIn) return <Navigate to="/login" replace />;

  return <Outlet />;
};

export default ProtectedRoute;
